export const GB_FEATURES = {
  EXP_NO_LOCATION_PUPPY_CARD: 'exp_no_location_puppy_card'
};
